<template>
    <nobr>
        <v-data-table
            v-if="data.length === 1 && data[0].coinbase"
            dense
            hide-default-footer
            :headers="[{ text: '', align: 'center', sortable: false}]"
            :items="data"
        >
            <template v-slot:item="{ item, expand, isExpanded }">
                <tr>
                    <td>
                        <span style="color: rgba(0,0,0,0.6)" class="font-weight-medium">
                            COINBASE INPUT
                        </span>
                    </td>
                </tr>
            </template>
        </v-data-table>

        <v-data-table
            v-else
            :headers="headers"
            :items="data"
            :items-per-page="50"
            dense
            item-key="addr"
            :footer-props="{
                'items-per-page-options':[50],
                'disable-items-per-page': true,
                'show-current-page': true,
                'showFirstLastPage': true,
                }"
            :hide-default-footer="data.length < 51"
        >
            <template v-slot:item="{ item, expand, isExpanded }">
                <transactionInputRow
                    :address="address"
                    :item="item"
                    :expand="expand"
                    :is-expanded="isExpanded"
                    :fiats="fiats"/>
            </template>
            <template v-slot:expanded-item="{ item: itemOuter }">
                <transactionInputRow
                    :address="address"
                    v-for="(item,index) in itemOuter.inouts"
                    :key="item.n"
                    :item="item"
                    :fiats="fiats"
                    :index="index"
                    :itemOuter="itemOuter"/>
            </template>
            <template #footer.prepend>
                <v-spacer/>
            </template>
            <template #footer.page-text="{ pageStart, pageStop, itemsLength }">
                <span>
                    {{ pageStart | formatNumber }} - {{ pageStop | formatNumber }} of {{ itemsLength | formatNumber }}
                </span>
            </template>
        </v-data-table>
    </nobr>
</template>

<script>
import AddressDetailable from "@/components/common/AddressDetailable";
import Copyable from "@/components/common/Copyable";
import addressCategory from '@/components/address/AddressCategoryIcon'
import FiatConvertor from "@/components/common/FiatConvertor";
import RouteToTransaction from "@/components/common/RouteToTransaction";
import RouteToAddress from "@/components/common/RouteToAddress";
import TransactionInputRow from "@/components/transaction/Components/TransactionInputRow";
export default {
    name: "TransactionInputTable",
    components: {
        TransactionInputRow,
        RouteToAddress,
        RouteToTransaction,
        FiatConvertor,
        Copyable,
        AddressDetailable,
        addressCategory},
    props: {
        data: {
            type: Array,
            required: true,
        },
        fiats: {

        },
        address: {

        }
    },
    data() {
        return {
            headers: [
                {
                    text: '',
                    align: "center",
                    sortable: false,
                    width: "0px",
                },
                {
                    text: 'Owners/Identities',
                    align: 'center',
                    sortable: false,
                    width: "92px",
                },
                {
                    text: 'Address',
                    align: 'center',
                    sortable: false,
                    width: '265px',
                },
                {
                    text: 'Categories',
                    align: 'center',
                    sortable: false,
                    width: '86px',
                },
                {
                    text: 'Value',
                    align: 'center',
                    sortable: true,
                    value: 'value'
                },
            ]
        }
    },
}
</script>

<style>

.countingBadges .v-badge__badge {
    inset: auto auto calc(100% - 8px) calc(100% - 11px) !important;
    font-size: 10px;
    height: 13px;
    padding: 2px 0px 1px 1px;
    min-width: 13px;
}

</style>